// firebase
import { db } from "config/firebase";
import { doc, getDoc } from "firebase/firestore";

// A ---------------------------------------------------------------------- M

const getSeenTag = async (uid, tagId) => {
  try {
    const seenTagRef = doc(db, "userdata", uid, "seentags", tagId);
    const snapshot = await getDoc(seenTagRef);

    if (!snapshot.exists()) {
      return null;
    }

    return {
      ...snapshot.data(),
      id: snapshot.id,
    };
  } catch (error) {
    console.error(`Error in getSeenTag for user ${uid} and tag ${tagId}:`, error);
    return null;
  }
};

export default getSeenTag;
